<template>
    <table class="table">
        <tr class="table__row">
            <th class="table__heading check-column" />
            <th class="table__heading id-column">
                {{ gridLangPack.ID }}
            </th>
            <th class="table__heading type-column">
                {{ gridLangPack.TYPE }}
            </th>
            <th class="table__heading url-column">
                {{ gridLangPack.TITLE }}
            </th>
            <th class="table__heading result-column" />
        </tr>

        <tr 
            v-for="entity in entities"
            :key="entity.TYPE + '_' + entity.ID"
            :class="GetRowClass(entity.TYPE, entity.BINDED)"
            class="table__row"
        >
            <td class="table__data">
                <input
                    type="checkbox"
                    @change="OnCheckHandler($event, entity)"
                >
            </td>
            <td class="table__data">
                {{ entity.ID }}
            </td>
            <td class="table__data">
                {{ GetTypeName(entity.TYPE) }}
            </td>
            <td class="table__data">
                <a
                    :href="entity.URL"
                    target="_blank"
                    @click="UrlClickHandler($event, entity.URL)"
                >{{ entity.TITLE }}</a>
            </td>
            <td class="table__data">
                <svg
                    v-if="entity.BINDED === true"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="rgb(78,216,146)"
                        fill-rule="evenodd"
                        d="M8.3549488 22c-.57337883 0-1.14675767-.25384615-1.55631399-.67692308L.9010239 15.31538462c-.90102389-.93076924-.90102389-2.36923077 0-3.3.9010239-.93076924 2.29351536-.93076924 3.19453925 0l4.09556314 4.14615384L19.74061433 1.18461538C20.4778157.16923077 21.95221843 0 22.85324233.84615385 23.83617746 1.6076923 24 3.13076923 23.18088736 4.06153846l-13.10580205 17.0076923c-.40955631.50769232-.98293515.84615386-1.63822525.84615386C8.43686007 22 8.43686007 22 8.3549488 22z"
                    />
                </svg>
            </td>
        </tr>
    </table>
</template>

<script>
const Table = {
    props: {
        langPack: {
            type: Object,
            require: true
        },
        entities: {
            type: Array,
            require: true
        },
        typeNames: {
            type: Object,
            require: true
        },
        value: {
            type: Object
        },
    },
    data() {
        return {
            gridLangPack: this.GetGridLangTitles(),
            selectedEntities: {},
        }
    },
    methods: {
        OnCheckHandler(event, entity) {
            let localId = entity.TYPE + "_" + entity.ID;
            if (!event.target.checked && this.selectedEntities[localId]) {
                delete this.selectedEntities[localId];
            }
            else if (event.target.checked) {
                this.selectedEntities[localId] = entity;
            }

            this.$emit('input', this.selectedEntities);
        },
        UrlClickHandler(event, url) {
            event.preventDefault();
            window.top.BX.SidePanel.Instance.open(url);
        },
        GetGridLangTitles() {
            return {
                ID: this.langPack["COMPONENT_JS_GRID_ID"] || "Id",
                TITLE: this.langPack["COMPONENT_JS_GRID_TITLE"] || "Entity title",
                TYPE: this.langPack["COMPONENT_JS_GRID_TYPE"] || "Entity type",
                URL: this.langPack["COMPONENT_JS_GRID_URL"] || "URL",
                VIEW: this.langPack["COMPONENT_JS_GRID_VIEW"] || "View",
            };
        },
        GetRowClass(type, binded = false) {
            let className = binded ? "table__row--binded" : "";
            return className;
        },
        GetTypeName(type) {
            return (this.typeNames[type] ?? this.typeNames["default"]).title;
        },
    },
    watch: {
        value(newValue) {
            this.selectedEntities = { ...newValue };
        }
    }
}
export default Table;
</script>

<style scoped>
    
.table {
    border-collapse: collapse;
    width: 100%;
    text-align: left;
}

.table__row {
    display: grid;
    grid-template-columns: 80px minmax(60px, 120px) minmax(150px, 1fr) minmax(150px, 1.67fr) 70px;
    text-align: left;
}

.table__row--binded td:not(:last-child) {
    background-color: rgba(78,216,146,0.2);
}

th {
    font-weight: 600;
    padding: 5px 0;
    background-color: #122136;
    color: #fff;
    text-transform: uppercase;
}

td {
    padding: 21px 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #C8C8C8;
}

td:first-child {
    padding: 20px 40px 20px 20px;
}

td:last-child {
    border-bottom: none;
}

th:last-child, 
td:last-child {
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 10px 20px;
    background-color: #fff;
    border: none;
    text-align: right;
}
</style>